import { clipboard } from "electron";
import * as React from "react";
import { FormControl, FormGroup } from "react-bootstrap";
import { findDOMNode } from "react-dom";
import { MainContext } from "../views/MainWindow";
import ContextMenu from "./ContextMenu";
function PlaceholderTextArea(props) {
    const { t, onChange, className, mModalRef } = props;
    const DEFAULT_PLACEHOLDER = "Paste token here";
    const { api } = React.useContext(MainContext);
    const [placeholder, setPlaceholder] = React.useState(() => t(DEFAULT_PLACEHOLDER));
    const [showContextMenu, setShowContextMenu] = React.useState(false);
    const [position, setPosition] = React.useState();
    const [value, setValue] = React.useState("");
    const handlePaste = () => {
        setValue(clipboard.readText());
    };
    const onShowContext = (event) => {
        setShowContextMenu(true);
        const modalDom = findDOMNode(mModalRef.current);
        const rect = modalDom.getBoundingClientRect();
        setPosition({ x: event.clientX - rect.x, y: event.clientY - rect.y });
    };
    const onHideContext = () => {
        setShowContextMenu(false);
    };
    const handleOnChange = (event) => {
        setValue(event.target.value);
        onChange?.(event);
    };
    return (React.createElement(FormGroup, { controlId: "" },
        React.createElement(FormControl, { className: className, componentClass: "textarea", draggable: false, placeholder: placeholder, value: value, onBlur: (e) => setPlaceholder(t(DEFAULT_PLACEHOLDER)), onChange: handleOnChange, onContextMenu: onShowContext, onFocus: (e) => setPlaceholder("") }),
        React.createElement(ContextMenu, { actions: [{ title: t("Paste"), action: handlePaste, show: true }], instanceId: "login-context", position: position, visible: showContextMenu, onHide: onHideContext })));
}
export default PlaceholderTextArea;
